// src/api_scripts/createOverrideList.js
import { createApiClient } from "../apiClient";

const createOverrideList = async (overrideListData, orgId, accessToken, setProgress) => {
  const { name } = overrideListData.name;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Override List: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // API endpoint for creating a new Override List
  const relativeUri = `organization/${orgId}/overrides`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, overrideListData);

    const newOverrideList = response.data; // The API returns the created resource directly

    console.log("Create Override List API Response Data:", newOverrideList);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Override List "${name}" (ID: ${newOverrideList.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newOverrideList.id; // Return the created override list object (includes its ID)

  } catch (error) {
    console.error(`Error creating Override List "${name}":`, error);

    let errorMessage = `Error creating Override List "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createOverrideList;
